<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3" id="calibre_pb_0"></div>
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Acknowledgments</span></h1>
<p class="p_normal"> </p>
<p class="p_normal"> </p>
<p class="p_norm-noindent"><span class="calibre4">A BIG</span> thank you to Kate and Corinth, who generously beta read this for me on a couple of days’ notice, and to my husband, who took the news that I was writing a second story on a short deadline with his usual acceptance and humor. Thanks to Jaye and her son, for taking time to fact-check me, and to everyone who suggested favorite movies. Thanks also to my farm consultant for answering questions—any errors I made in representing Minnesota farm life are entirely my own.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?a5f5e03e